module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAwBAMAAABeexFrAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURevBAt8AECQYFtUAENgCEiIYFiYcGiIYFPXJAOEAEnwziYwAAAAHdFJOU+X14/Pl5dy5QWQZAAAAPElEQVQ4y2NIUiIE1BjCywmB0lE1I1SNszEhYMLgOZMQmDKqZhiqcRYWNsYLDU0YODoIgYZRNSNUDREAAEEYMjvTbYOYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/germany.png
// module id = HxpF
// module chunks = 34